import { makeAutoObservable } from 'mobx'
import { Attachment } from 'entities/Attachment/model/Attachment'
import type { IResponseKeyword } from 'entities/Keywords/api/type'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import {
  SMSMessageFieldStore,
  type ISMSMessageFieldStoreProps,
} from 'widgets/MessageFormFields/SMSMessageField/store/SMSMessageFieldStore'

export class KeywordSMSStore {
  smsMessageFieldStore: SMSMessageFieldStore
  constructor(props: ISMSMessageFieldStoreProps, private _entities: IEntitiesStore) {
    this.smsMessageFieldStore = new SMSMessageFieldStore(props, this._entities)
    makeAutoObservable(this)
  }

  init = (keywordResponse: IResponseKeyword) => {
    this.messageFieldStore.setMessageData({
      attachments:
        keywordResponse.media_url?.map((media) => new Attachment({ responseMediaShort: media })) ||
        [],
      message: keywordResponse.message || '',
      isFocus: false,
      isReset: false,
      isReplace: true,
    })
  }

  get messageDataParams() {
    return this.smsMessageFieldStore.messageDataParams
  }

  get messageFieldStore() {
    return this.smsMessageFieldStore.messageFieldStore
  }

  get isError() {
    return this.smsMessageFieldStore.isError
  }

  get segments_count() {
    return this.smsMessageFieldStore.segments_count
  }
}
